export const detailedLoanLCV1 = [
  "ToorakFICObucket",
  "toorakLoanType",
  // "FinalLoanCharacterization",
];
